import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { ASSETS_PATH_CONST } from '../modern-multi-trip-view/constants/image-assets.constants';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.html',
  styleUrls: ['./page-not-found.scss']
})
export class PageNotFound implements OnInit {
  
  page_not_found: AnimationOptions = {
    path: ASSETS_PATH_CONST.PAGE_NOT_FOUND,
  };

  errorMessage:string = "404 - Page Not found";

  ngOnInit(): void {
  }

}
